import * as Long from "long";
import * as React from "react";
import { connect } from "react-redux";
import { IdStyles } from "../../less/IdStyles";
import { selectXpInfo } from "../../selectors/selectXpInfo";
import { IdLoca } from "../../utils/i18n/IdLoca";
import { ReplacementLoca } from "../../utils/i18n/ReplacementLoca";
import { utilNumber } from "../../utils/utilNumber";
import { TextLoca } from "../generic/text/TextLoca";
import "./xptooltip.less";
var _XpTooltip = function (_a) {
    var xp = _a.xp, nextLevel = _a.nextLevel;
    var xpToNextLevel = nextLevel != undefined ? Long.fromValue(nextLevel.requiredXp).subtract(xp) : Long.ZERO;
    var formattedXp = utilNumber.format(xpToNextLevel);
    var locaReplacements = new Map([[ReplacementLoca.zero_0, formattedXp]]);
    return (React.createElement(TextLoca, { id: IdLoca.floatingText_xplevelup, replacements: locaReplacements, className: IdStyles.TextSmall + " xp-hud-tooltip" }));
};
export var XpTooltip = connect(selectXpInfo)(_XpTooltip);



//////////////////
// WEBPACK FOOTER
// ./src/features/xp/XpTooltip.tsx
// module id = 2300
// module chunks = 3